import { render, staticRenderFns } from "./orthobuilder.vue?vue&type=template&id=a861a070&scoped=true"
import script from "./orthobuilder.vue?vue&type=script&lang=js"
export * from "./orthobuilder.vue?vue&type=script&lang=js"
import style0 from "./orthobuilder.vue?vue&type=style&index=0&id=a861a070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a861a070",
  null
  
)

export default component.exports